// Styles
import '../styles/main.scss'

// Modules
import GlideConfig from './modules/glide-config'
import Galerie from './modules/galerie'
import Hamburger from './modules/hamburger'
import Search from './modules/search'

const glideConfig = new GlideConfig()
const galerie = new Galerie()
const hamburger = new Hamburger()
const search = new Search()
